<template>
  <div>
    <el-tabs value="tab_pannel" type="border-card" v-model="activeName">
      <el-tab-pane label="产品信息" name="tab_1">


        <el-form ref="form" :model="formQuery" inline size="mini">

          <el-form-item label="产品ID：">
            <el-input v-model="formQuery._id"></el-input>
          </el-form-item>

          <el-form-item label="产品名字：">
            <el-input v-model="formQuery.productName"></el-input>
          </el-form-item>

          <el-form-item label="保司ID：">
            <el-input v-model="formQuery.baosiId"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click.native.prevent="()=>{formVisible=true, isEdit=false}">添加商品</el-button>
            <el-button type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>

        <el-table :data="List" size="mini" style="color: green">
          <el-table-column type="expand">
            <template v-slot:="props">
              <vue-json-editor v-model="props.row" :showBtns="true"></vue-json-editor>
            </template>
          </el-table-column>
          <el-table-column label="商品ID" prop="_id" width="150" sortable/>
          <el-table-column label="名字" prop="name" width="150" sortable/>
          <el-table-column label="类型" width="80">
            <template slot-scope="scope">
              {{ getProductTypeDesc(scope.row.type) }}
            </template>
          </el-table-column>
          <el-table-column label="子类型" width="100">
            <template slot-scope="scope">
              {{ getProductSubTypeDesc(scope.row.subType) }}
            </template>
          </el-table-column>
          <el-table-column label="支付类型" width="200">
            <template slot-scope="scope">
              {{ getPayTypeDesc(scope.row.payType) }}
            </template>
          </el-table-column>
          <!--          <el-table-column label="数量" prop="num" width="100"/>-->
          <el-table-column label="价格" prop="extra.premium" width="50"/>
          <el-table-column label="被保人限制" width="100">
            <template slot-scope="scope">
              {{ scope.row.bbrLimit > 0 ? scope.row.bbrLimit : '无限制' }}
            </template>
          </el-table-column>
          <el-table-column label="保司" prop="baosiName" width="100"/>
          <el-table-column label="销售主体" prop="baosiId" width="100" :formatter="getSaleEntity"/>
          <el-table-column label="保司状态" prop="baosiState" width="80">
            <template v-slot:="scope">
              <el-tag :type="getActiveStateTagInfo(scope.row.baosiState).tag">
                {{ getActiveStateTagInfo(scope.row.baosiState).label }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="状态" prop="state" width="80">
            <template v-slot:="scope">
              <el-tag :type="getActiveStateTagInfo(scope.row.state).tag">
                {{ getActiveStateTagInfo(scope.row.state).label }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="600">
            <template v-slot:="scope">
              <p v-if="scope.row.baosiState !== ActiveState.Normal">将保司修改为正常状态，才可以修改该商品</p>
              <div v-else>
                <el-button style="margin-left: 10px;"
                           size="mini"
                           @click="handleEditVisible(scope.row)">编辑
                </el-button>

                <el-button style="margin-left: 10px;"
                           size="mini"
                           type="warning"
                           @click="handleChangeState(scope.row, 1)">冻结
                </el-button>

                <el-button style="margin-left: 10px;"
                           size="mini"
                           type="warning"
                           @click="handleChangeState(scope.row, 2)">下架
                </el-button>
                <el-button style="margin-left: 10px;"
                           size="mini"
                           @click="handleChangeState(scope.row, 0)">还原
                </el-button>

                <el-button style="margin-left: 10px;"
                           size="mini"
                           type="danger"
                           @click="handleDelete(scope.row)">删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <Pagination ref="pagination" @change="onPageChange"></Pagination>
      </el-tab-pane>


    </el-tabs>
    <el-dialog title="商品信息" :visible.sync="formVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="form" size="mini">

        <el-form-item v-if="!isEdit" label="商品ID：">
          <el-input v-model="form._id"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item v-if="!isEdit" label="保险公司产品ID：">
          <el-input v-model="form.realId"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="商品名字：">
          <el-input v-model="form.name"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="商品名字(英文版)：">
          <el-input v-model="form.nameEN"
                    placeholder=""
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input>
        </el-form-item>

        <el-form-item label="被保人数量限制：">
          <el-input-number v-model="form.bbrLimit"
                    placeholder="0为无限制"
                    size="mini"
                    :precision="0"
                    :min="0"
          ></el-input-number>
          <span style="margin-left: 10px; color: #909399;">0为无限制，大于0为限制数量</span>
        </el-form-item>

        <el-form-item label="被保人年龄限制：">
          <el-input-number v-model="form.bbrAgeLimit[0]"
                    placeholder="最小年龄"
                    size="mini"
                    :precision="0"
                    :min="0"
                    :max="150"
          ></el-input-number>
          <span style="margin: 0 10px;">~</span>
          <el-input-number v-model="form.bbrAgeLimit[1]"
                    placeholder="最大年龄"
                    size="mini"
                    :precision="0"
                    :min="0"
                    :max="150"
          ></el-input-number>
          <span style="margin-left: 10px; color: #909399;">均为0表示无限制</span>
        </el-form-item>

        <el-form-item label="商品信息：">
          <el-input v-model="form.info"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>

        <el-form-item v-if="!isEdit" label="选择保司公司：">
          <el-select
              style="width: 500px;"
              v-model="form.baosiId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteBaoSi"
              :loading="loading">
            <el-option
                v-for="item in baosiList"
                :key="item._id"
                :label="`${item.name}（${item._id}）`"
                :value="item._id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图片">
          <file-upload ref="fileUpload" v-model="fileList"></file-upload>
        </el-form-item>

        <el-form-item label="附件文件">
          <div v-if="existingFiles.length" style="margin-bottom: 8px;">
            <div v-for="(file, index) in existingFiles" :key="file.path"
                 style="display: flex; align-items: center; margin-bottom: 4px;">
              <a :href="storageBase + '/' + file.path" target="_blank"
                 style="margin-right: 10px; color: #409EFF;">{{ file.name }}</a>
              <el-button size="mini" type="danger" icon="el-icon-delete"
                         @click="removeExistingFile(index)">删除</el-button>
            </div>
          </div>
          <file-upload ref="attachFileUpload" v-model="attachFileList" :maxSize="10"></file-upload>
        </el-form-item>

        <el-form-item label="支付类型:">
          <el-select
              v-model="form.payTypeList"
              multiple
              filterable
              allow-create
              default-first-option
              placeholder="支付类型"
              :width="500">
            <el-option
                v-for="item in OptsPayType"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="extra：">
          <vue-json-editor v-model="form.extra" :showBtns="true"></vue-json-editor>
        </el-form-item>

        <el-form-item v-if="!isEdit" label="险种：">
          <el-select v-model="form.type" placeholder="please select your zone">
            <el-option
                v-for="item in optsProductType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <div v-if="form.type === ProductType.HY">
        </div>
        <div v-else-if="form.type === ProductType.LY">
          <el-form-item label="子类型1：">
            <el-select
                v-model="form.subTypeList"
                multiple
                filterable
                allow-create
                default-first-option
                placeholder="选择子类型"
                style="width: 500px;">
              <el-option
                  v-for="item in optsProductSubType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="生效类型：">
            <el-select v-model="form.effectRules" placeholder="please select your zone">
              <el-option
                  v-for="item in OptsEffectRules"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="国家编号：">
            <el-transfer
                v-model="form.countryList"
                filterable
                :filter-method="filterMethod"
                :props="{
                key: 'value',
                label: 'label'
              }"
                :data="OptsCountryCode">
            </el-transfer>
          </el-form-item>


          <el-form-item label="方案：">
            <vue-json-editor v-model="form.plans" :showBtns="true"></vue-json-editor>
          </el-form-item>
        </div>

        <el-form-item label="责任：">
          <el-input v-model="form.zr"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>

        <el-form-item label="责任(英文版)：">
          <el-input v-model="form.zrEN"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>

        <el-form-item label="理赔：">
          <el-input v-model="form.lp"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>

        <el-form-item label="条款：">
          <el-input v-model="form.tk"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>

        <el-form-item label="隐私：">
          <el-input v-model="form.ys"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>
        <el-form-item label="须知及声明：">
          <el-input v-model="form.xzsm"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>
        <el-form-item label="特别约定：">
          <el-input v-model="form.yd"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>

        <el-form-item label="服务协议：">
          <el-input v-model="form.fwxy"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>

        <el-form-item label="客户告知书：">
          <el-input v-model="form.gzs"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>

        <el-form-item label="免责条款：">
          <el-input v-model="form.mztk"
                    type="textarea"
                    autosize
          ></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native.prevent="handleCancel">取 消</el-button>
        <template v-if="!isEdit">
          <el-button type="primary" @click.native.prevent="handleAdd">添加</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click.native.prevent="handleEdit">编辑</el-button>
        </template>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import * as _ from 'lodash';
import VueJsonEditor from '@/components/VueJsonEditor'
import FileUpload from '@/components/FileUpload'
import {
  getSaleEntity,
  getActiveStateTagInfo,
  OptsProductType,
  getOptsList,
  OptsProductSubType,
  OptsPayType,
  OptsCountryCode, OptsEffectRules
} from "@/utils";
import {
  ProductSubType,
  ProductType,
  ActiveState,
  getProductTypeDesc,
  getProductSubTypeDesc,
  getPayTypeDesc, EffectRules,
} from "@/utils/constants";
import Pagination from "@/components/Pagination.vue";

export default {
  data() {
    return {
      loading: false,
      activeName: 'tab_1',

      //产品查询
      formQuery: {
        _id: "",
        baosiId: "",
        qiyeName: "",
        productName: "",
        type: ProductType.None,
      },
      // 保险类型
      optsProductType: getOptsList(OptsProductType, ProductType.HY | ProductType.LY),
      // 子类型
      optsProductSubType: getOptsList(OptsProductSubType, ProductSubType.CJY |
          ProductSubType.GNY | ProductSubType.ZJY | ProductSubType.JWYX | ProductSubType.SGQZ | ProductSubType.YDHW),
      // 国家编号
      OptsCountryCode,
      // 支付类型
      OptsPayType,
      // 生效类型
      OptsEffectRules,

      // 列表
      List: [],
      formVisible: false,
      form: this.getDefaultForm(),
      inputHistory: [],
      baosiList: [],
      isEdit: false,
      fileList: [],
      attachFileList: [],
      existingFiles: [],
      storageBase: process.env.VUE_APP_STORAGE_LOCATION || '',
      getActiveStateTagInfo,
      getSaleEntity,
      ProductType,
      ActiveState,
      filterMethod(query, item) {
        return item.label.indexOf(query) > -1;
      }
    }
  },
  methods: {
    getProductSubTypeDesc,
    getProductTypeDesc,
    getPayTypeDesc,
    remoteBaoSi(query) {
      if (query !== '') {
        this.loading = true;

        let params = {
          query
        }

        this.$axios.post('/baosi/quick/list', params).then(res => {
          this.baosiList = res.baosi;
          this.loading = false;
        }).catch(res => {
          this.loading = false;
        })
      } else {
        this.baosiList = [];
      }
    },

    handleCancel: function () {
      this.formVisible = false;
      this.resetProduct();
    },

    getDefaultForm: function () {
      return {
        _id: "",
        realId: "",
        name: "",
        nameEN: "",
        bbrLimit: 0,
        bbrAgeLimit: [0, 0],
        type: ProductType.HY,
        effectRules: EffectRules.Now,
        subTypeList: [],
        payTypeList: [],
        countryList: [],
        pic: [],
        info: "",
        baosiId: "",
        num: 99999,
        //保险责任
        zr: "",
        zrEN: "",
        //理赔说明
        lp: "",
        extra: {
          validDays: 0,
          premium: 0,
          needFlightInfo: false,
        },
        tk: "",
        ys: "",
        xzsm: "",
        yd: "",
        gzs: '',
        fwxy: '',
        mztk: '',
        plans: {}
      }
    },

    resetProduct: function () {
      this.form = this.getDefaultForm();
      this.formVisible = false;
      this.fileList = [];
      this.attachFileList = [];
      this.existingFiles = [];
      this.isEdit = false;
      if (this.$refs.fileUpload) {
        this.$refs.fileUpload.clearFiles();
      }
      if (this.$refs.attachFileUpload) {
        this.$refs.attachFileUpload.clearFiles();
      }
    },

    handleEditVisible(row) {
      this.form = row
      if (!this.form.bbrAgeLimit || !Array.isArray(this.form.bbrAgeLimit)) {
        this.$set(this.form, 'bbrAgeLimit', [0, 0]);
      }
      this.formVisible = true;
      this.isEdit = true;
      // 已有附件转为预览列表
      const filesMap = row.files || {};
      this.existingFiles = Object.entries(filesMap).map(([key, path]) => ({
        key,
        name: String(path).split('/').pop(),
        path: String(path),
      }));
      this.$nextTick(() => {
        this.$refs.fileUpload.loadFiles(row.pic || {});
        if (this.$refs.attachFileUpload) {
          this.$refs.attachFileUpload.clearFiles();
        }
      });
    },

    removeExistingFile(index) {
      this.existingFiles.splice(index, 1);
    },

    async handleEdit(row) {
      // 合并已有文件和新上传文件
      const newFiles = await this.$refs.attachFileUpload.getFiles();
      // 把保留的已有文件通过服务端下载再上传回去（保持全量替换逻辑一致）
      const existingFileData = [];
      for (const file of this.existingFiles) {
        try {
          const response = await this.$axios({
            method: 'get',
            url: `/download/${encodeURIComponent(file.path)}`,
            responseType: 'arraybuffer',
          });
          const base64 = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
          existingFileData.push({name: file.name, data: base64});
        } catch (e) {
          console.error('加载已有文件失败', e);
        }
      }
      const params = {
        files: await this.$refs.fileUpload.getFiles(),
        attachFiles: [...existingFileData, ...newFiles],
        productId: this.form._id,
        single: true,
        subType: _.sum(this.form.subTypeList),
        payType: _.sum(this.form.payTypeList),
      }
      const params1 = _.merge({}, this.form, params);
      this.$axios.post('/product/update', params1).then(res => {
        this.$message.info('修改商品成功');
      }).catch(res => {
      })
    },

    handleChangeState: function (row, state) {
      let params = {
        productId: row._id,
        state,
        baosiId: row.baosiId
      }
      this.$axios.post('/product/state/change', params).then(res => {
        this.$message.info('改变商品状态成功');
      }).catch(res => {
      })
    },

    handleDelete: function (row) {
      this.$confirm("确认删除商品？", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "red"
      }).then(() => {

        let params = {
          productId: row._id,
        }
        this.logining = true;
        this.$axios.post('/product/delete', params).then(res => {
          this.$message.info('删除商品成功');
          this.logining = false;
        }).catch(res => {
          this.logining = false;
        })

      }).catch(() => {
      })
    },

    async handleAdd() {
      const files = await this.$refs.fileUpload.getFiles();
      const attachFiles = await this.$refs.attachFileUpload.getFiles();
      const params = {
        files,
        attachFiles,
        productId: this.form._id,
        baosiId: this.form.baosiId,
        subType: _.sum(this.form.subTypeList),
        payType: _.sum(this.form.payTypeList),
      }
      const params1 = _.merge({}, this.form, params);
      this.logining = true;
      this.$axios.post('/product/add', params1).then(res => {
        this.$message.info('添加商品成功');
        this.logining = false;
      }).catch(res => {
        this.logining = false;
      })
      this.resetProduct();
    },

    onPageChange: function (pageSize, currentPage) {
      this.query((currentPage - 1) * pageSize, pageSize);
    },

    query: function (offset, limit) {
      const params = {
        productId: this.formQuery._id,
        limit,
        offset
      }
      const params1 = _.merge({}, this.formQuery, params);
      this.$axios.post('/product/list', params1).then(res => {
        this.$message.info('查询商品成功');
        this.List = _.map(res.product, (item) => {
          item.subTypeList = _.map(getOptsList(OptsProductSubType, item.subType), (v) => v.value);
          item.payTypeList = _.map(getOptsList(OptsPayType, item.payType), (v) => v.value);
          return item;
        })
        if (offset === 0) {
          this.$refs.pagination.reset(res.count);
        } else {
          this.$refs.pagination.setTotal(res.count);
        }
      }).catch(res => {
        this.logining = false;
      })
    },

    handleQuery: function () {
      this.query(0, this.$refs.pagination.getSize());
    },
  },

  watch: {},

  created() {
  },

  components: {Pagination, VueJsonEditor, FileUpload},
}
</script>

<style scoped>
</style>
